/* eslint-disable camelcase */
import { trackClick, trackPage } from "@companion-core/shared/app/tracking/index";
import ClickTypes from "@companion-core/shared/app/tracking/enums/click-types";

interface DynamicFormStepParams {
  page: string;
  page_chapter1: string;
  page_chapter2?: string;
  page_chapter3?: string;
  site_level2?: number;
}

interface DynamicFormClickParams {
  clickName: string;
  click_chapter1: string;
  click_chapter2?: string;
  click_chapter3?: string;
  site_level2?: number;
}

export function trackStepDynamicForm({
  page,
  page_chapter1,
  page_chapter2 = "",
  page_chapter3 = "",
  site_level2,
}: DynamicFormStepParams) {
  return trackPage({
    page,
    page_chapter1,
    page_chapter2,
    page_chapter3,
    site_level2,
  });
}

export function trackClickDynamicForm({
  clickName,
  click_chapter1,
  click_chapter2 = "",
  click_chapter3 = "",
  site_level2,
}: DynamicFormClickParams) {
  return trackClick({
    click: clickName,
    click_type: ClickTypes.Navigation,
    click_chapter1,
    click_chapter2,
    click_chapter3,
    site_level2: site_level2,
  });
}
